module.exports = __webpack_public_path__ + "static/img/demo-team.9d85407f.svg";